import React from 'react';

export default function Resume(props) {
  return (

    <div id='resume' className='-z-50 md:pl-[350px] pl-14 pr-14 pt-16 pb-16 flex flex-col space-y-4 ' onMouseOver={() => props.onHover("resume")}>
      
      <h1 className='text-3xl pt-2 font-[650] text-[#173b6c] '>Resume</h1>

      <hr className='relative pb-4 w-12 border-t-4 border-blue-400' />
      
      <span>You can find the PDF versions of my one-page <a href="https://drive.google.com/file/d/1zbtvnssruGqFknPL-xjaonvS8dd4Qdcf/view?usp=sharing" target="_blank" rel="noreferrer" className='text-blue-400'>resume</a>  here!</span>
      
      
    </div>

  )
}
